import { UseQueryOptions } from '@tanstack/react-query';

import {
  useMadeOffersCount as useMadeOffersCountBaseHook,
  MadeOffersCount,
  MadeOffersCountVariables,
} from 'gql/hasura/queries/made-offers-count.generated';
import { isAllTrue } from 'utils/helpers';

const currentDate = new Date().toISOString();

export default function useMadeOffersCount(
  variables: Pick<MadeOffersCountVariables, 'publicKey'>,
  options?: UseQueryOptions<MadeOffersCount, Error, number>
) {
  return useMadeOffersCountBaseHook(
    { ...variables, currentDate },
    {
      ...options,
      enabled: isAllTrue(Object.values(variables)),
      select: (data) => {
        return data?.madeOffersCount?.aggregate?.count || 0;
      },
    }
  );
}
